const findIndexReversed = <T>(
    items: T[],
    predicate: (item: T) => boolean
): number => {
    const currentReversedIndex = [...items].reverse().findIndex(predicate);
    return currentReversedIndex > 0
        ? items.length - 1 - currentReversedIndex
        : currentReversedIndex;
};

export { findIndexReversed };
